import { useState } from "react";
import { IconButton, Tooltip, SxProps, Theme } from "@mui/material";
import { ContentCopy, Check } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import colors from "../../Constants/colors";

interface CopyButtonProps {
  content: string;
  size?: "small" | "medium" | "large";
  color?: string;
  sx?: SxProps<Theme>;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  content,
  size = "small",
  color = colors.gray600,
  sx,
}) => {
  const { t } = useTranslation("singleCompanyComponent");
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Tooltip
      title={
        isCopied ? t("sectionChat.tooltipCopied") : t("sectionChat.tooltipCopy")
      }
    >
      <IconButton
        size={size}
        onClick={handleCopy}
        sx={{
          p: 0.25,
          color: color,
          "&:hover": { bgcolor: "rgba(0, 0, 0, 0.04)" },
          ...sx,
        }}
      >
        {isCopied ? (
          <Check sx={{ fontSize: "0.9rem" }} />
        ) : (
          <ContentCopy sx={{ fontSize: "0.9rem" }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
